import { PublishedWithChanges } from "@mui/icons-material";
import { Alert } from "@mui/material";

export default function VerifyingProof(){
    return (
        <Alert severity="info" icon={<PublishedWithChanges />}>
            Votre justificatif étudiant est en cours de vérification. Vous serez notifié une fois validé et pourrez alors bénéficier du tarif étudiant. Pour rappel, le tarif étudiant ne s'adresse qu'aux étudiants hors DU non thésés qui ne sont pas encore en exercice (sans numéro RPPS). 
        </Alert>
    );
}